import { useEffect, useRef } from 'react';

const AboutSection = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-8');
          }
        });
      },
      { threshold: 0.12 }
    );
    ref.current?.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-[#0F172A] py-28 lg:py-36">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Image */}
          <div className="reveal opacity-0 translate-y-8 transition-all duration-700">
            <div className="relative overflow-hidden rounded-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/a664ec9120b590ad7178183edd118d13.jpg"
                alt="LOPES BUSINESS — Assessoria Internacional"
                className="w-full h-[480px] object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/50 to-transparent" />
            </div>
          </div>

          {/* Text */}
          <div className="flex flex-col gap-6">
            <div className="reveal opacity-0 translate-y-8 transition-all duration-700">
              <span className="font-sans text-xs font-medium tracking-[0.3em] uppercase text-[#C9A96E] block mb-4">
                Sobre a empresa
              </span>
              <h2 className="font-serif text-4xl md:text-5xl font-light text-white leading-snug">
                Inteligência estratégica desde 2018.
              </h2>
            </div>

            <div className="reveal opacity-0 translate-y-8 transition-all duration-700 delay-100">
              <p className="font-sans text-base font-light text-white/60 leading-relaxed">
                A Lopes Business é especializada em assessoria estratégica esportiva,
                estruturação financeira e proteção patrimonial — construindo uma base
                sólida para atletas profissionais e empresários que exigem o mais alto
                padrão de excelência.
              </p>
            </div>

            <div className="reveal opacity-0 translate-y-8 transition-all duration-700 delay-150">
              <p className="font-sans text-base font-light text-white/60 leading-relaxed">
                Nosso modelo de atuação é fundamentado em confidencialidade absoluta,
                inteligência estratégica e conexões globais — entregando resultados
                extraordinários a quem opera no mais alto nível.
              </p>
            </div>

            {/* Values row */}
            <div className="reveal opacity-0 translate-y-8 transition-all duration-700 delay-200 flex items-center gap-8 pt-6 border-t border-white/5">
              {[
                { icon: 'ri-shield-check-line', label: 'Confidencialidade' },
                { icon: 'ri-global-line', label: 'Alcance Global' },
                { icon: 'ri-award-line', label: 'Alta Performance' },
              ].map((val, i) => (
                <div key={i} className="flex flex-col items-center gap-2 text-center">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full border border-[#C9A96E]/25">
                    <i className={`${val.icon} text-[#C9A96E] text-base`} />
                  </div>
                  <span className="font-sans text-[10px] font-medium tracking-[0.2em] uppercase text-white/40">
                    {val.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
